import { request as __request } from '../request/request';
import { OpenAPI } from '../request/open-api';
import { CancelablePromise } from 'api/request/cancelable-promise';
import { RequestPaginatedResponseDto, RequestResponseDto } from 'types/types';
import { RequestStatus, SortOrder } from 'types/enums';

export const getPaginatedRequests = (
  limit: number,
  skip: number,
  statusSort: RequestStatus,
  dateSort: SortOrder,
  statusFilter?: RequestStatus | null,
): CancelablePromise<RequestPaginatedResponseDto> => {
  return __request(OpenAPI, {
    method: 'GET',
    url: `/requests/`,
    query: {
      limit: limit,
      skip: skip,
      sort_by_date: dateSort,
      sort_by_status: statusSort,
      status_filter: statusFilter,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const updateRequest = (payload: RequestResponseDto): CancelablePromise<RequestResponseDto> => {
  return __request(OpenAPI, {
    method: 'PUT',
    url: `/requests/`,
    body: payload,
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};
